import { addContent, getContent } from "@js/helpers/state.js";

import {
  CE_ADD_NEW_CONTENT,
  CE_DUPLICATE_CONTENT,
} from "@js/actions/studio/campaign_content_section/generate_content.js";

const nameIsAvailable = (state, name) => {
  // Test if our desired name is available
  let desiredNameAvailable = true;

  for (let content of state.data.contents) {
    if (content.name.toLowerCase() === name.toLowerCase()) {
      desiredNameAvailable = false;
    }
  }

  return desiredNameAvailable;
};

const newContentName = (state, suggestion) => {
  let desiredName = suggestion || "Content (1)";

  if (nameIsAvailable(state, desiredName)) return desiredName;

  let basename, match;

  if ((match = desiredName.match(/^(.*) \((\d+)\)$/))) {
    basename = match[1];
  } else {
    basename = desiredName;
  }

  // Treat the desired name as our starting case
  let newName = desiredName;

  // Then increment the (#) until we find a name that is available
  for (let i = 1; !nameIsAvailable(state, newName); i++) {
    newName = `${basename} (${i})`;
  }

  return newName;
};

export default (state = {}, action) => {
  switch (action.type) {
    case CE_ADD_NEW_CONTENT: {
      // New content is being created. Add it to the content list.

      let content = {
        name: newContentName(state, null),
        subject: "",
        format: action.format,
        html: "",
        text: "",
        bee_json: null,
        active_html_editor: action.active_html_editor,
      };

      return addContent(state, content);
    }

    case CE_DUPLICATE_CONTENT: {
      // Duplicating an existing content.

      let content = getContent(state, action.client_content_id);

      let contentWithNewName = {
        ...content,
        name: newContentName(state, content.name),
      };

      return addContent(state, contentWithNewName);
    }

    default:
      return state;
  }
};
